<template>
    <div>
        <loading
            :active.sync="loadingApp"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#0B8BCC'"
            :loader="'dots'"
            :opacity="0.7"
            :lock-scroll="true"
        ></loading>
        <Toast
            :show.sync="toast.show"
            :message="toast.message"
            :tipe="toast.tipe"
            @close="toast.show = false"
            :position="toast.position"
            :icon="toast.icon"
        ></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light">
            <div class="left">
                <router-link :to="{ name: 'home' }" class="headerButton">
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </router-link>
            </div>
            <div class="pageTitle">Pendaftaran QRIS Merchant</div>
        </div>
        <!-- * App Header -->

        <div id="appCapsule" class="pb-0" v-if="loadingApp == false">
            <div class="mt-2" v-if="showOpeningSlider">
                <div class="section full">
                    <div class="mb-2">
                        <div>
                            <carousel
                                ref="carouselOpening"
                                :autoplay="false"
                                :nav="false"
                                :dots="true"
                                :loop="false"
                                :items="1"
                                :stagePadding="20"
                                :margin="20"
                                :rewind="false"
                                @changed="onCarouselChanged"
                            >
                                <img
                                    v-for="item in sliderOpening"
                                    :key="item.id"
                                    :src="item.urlImage"
                                    class="imaged"
                                    :alt="item.id"
                                />
                            </carousel>
                        </div>
                    </div>
                </div>
                <div class="section">
                    <div class="text-center mb-1" style="line-height: 18px">
                        <small
                            >Geser
                            <ion-icon name="arrow-forward-outline"></ion-icon>
                            dan Lihat semua gambar diatas untuk dapat mengklik
                            tombol dibawah ini</small
                        >
                    </div>
                    <button
                        class="btn btn-primary btn-block btn-lg"
                        @click="modalTermOfService('show')"
                        :disabled="!showButtonRegister"
                    >
                        Daftar Sekarang
                    </button>
                </div>
            </div>
            <div class="mt-2" v-else>
                <div class="section">
                    <div class="mb-2">
                        <ul class="listview image-listview inset m-0">
                            <li>
                                <router-link
                                    :to="{ name: 'account.data-diri' }"
                                    class="item"
                                >
                                    <div class="icon-box bg-light">
                                        <ion-icon
                                            name="person-outline"
                                        ></ion-icon>
                                    </div>
                                    <div class="in">
                                        <div>
                                            <div style="margin-bottom: 5px">
                                                Verifikasi Data Diri (KYC)
                                            </div>
                                            <div class="footer">
                                                <span
                                                    class="badge badge-success-custom"
                                                    v-if="
                                                        customer.account_verified_data &&
                                                        customer
                                                            .account_verified_data
                                                            .status ==
                                                            'APPROVED'
                                                    "
                                                    >Terverifikasi</span
                                                >
                                                <span
                                                    v-else
                                                    class="badge badge-grey-custom"
                                                    >Belum Terverifikasi</span
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </router-link>
                            </li>
                            <li>
                                <router-link
                                    :to="{ name: 'account.business' }"
                                    class="item"
                                >
                                    <div class="icon-box bg-light">
                                        <ion-icon
                                            name="storefront-outline"
                                        ></ion-icon>
                                    </div>
                                    <div class="in">
                                        <div>
                                            <div style="margin-bottom: 5px">
                                                Info Usaha
                                            </div>
                                            <div class="footer">
                                                <span
                                                    class="badge badge-success-custom"
                                                    v-if="
                                                        customer.customer_business
                                                    "
                                                    >Lengkap</span
                                                >
                                                <span
                                                    class="badge badge-grey-custom"
                                                    v-else
                                                    >Belum Lengkap</span
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </router-link>
                            </li>
                        </ul>
                    </div>
                    <div class="mb-2">
                        <ul class="listview image-listview inset m-0">
                            <li>
                                <a
                                    href="Javascript:;"
                                    class="item"
                                    @click="modalOptionProviders('show')"
                                >
                                    <div class="icon-box bg-light">
                                        <ion-icon
                                            name="qr-code-outline"
                                        ></ion-icon>
                                    </div>
                                    <div class="in">
                                        <div>
                                            <div style="margin-bottom: 5px">
                                                Pilih Jenis QRIS dan Penerbit
                                            </div>
                                            <footer>
                                                <div>
                                                    <strong>{{
                                                        selectProviderData.name
                                                            ? selectProviderData.name
                                                            : '-'
                                                    }}</strong>
                                                </div>
                                                <div>
                                                    <small
                                                        v-if="
                                                            selectProviderData.provider_by
                                                        "
                                                        >Diterbitkan oleh
                                                        <b>{{
                                                            selectProviderData.provider_by
                                                        }}</b></small
                                                    >
                                                </div>
                                            </footer>
                                        </div>
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div class="mb-2">
                        <div
                            class="alert alert-warning-custom mb-2"
                            v-if="selectProviderData.name"
                        >
                            <div
                                class="text-secondary"
                                style="font-size: 12px; line-height: 18px"
                            >
                                <dt>Biaya MDR (Per Transaksi)</dt>
                                <dd>
                                    Berdasarkan nominal transaksi :
                                    <ul>
                                        <li
                                            v-for="item in selectProviderData.qris_payment_fees"
                                            :key="item.id"
                                        >
                                            <div v-if="item.max_amount > 0">
                                                <span
                                                    >Rp{{
                                                        item.min_amount | rupiah
                                                    }}</span
                                                >
                                                s.d
                                                <span>
                                                    Rp
                                                    {{
                                                        item.max_amount | rupiah
                                                    }}</span
                                                >
                                                =
                                                {{
                                                    item.fee_type == 'FIXED'
                                                        ? 'Rp'
                                                        : ''
                                                }}
                                                {{ item.fee_value
                                                }}{{
                                                    item.fee_type == 'PERCENT'
                                                        ? '%'
                                                        : ''
                                                }}
                                            </div>
                                            <div v-else>
                                                ≥
                                                <span
                                                    >Rp{{
                                                        item.min_amount | rupiah
                                                    }}</span
                                                >
                                                = {{ item.fee_value }}%
                                            </div>
                                        </li>
                                    </ul>
                                </dd>
                            </div>
                            <div
                                class="text-secondary"
                                style="font-size: 12px; line-height: 18px"
                                v-html="selectProviderData.description"
                            ></div>
                        </div>
                    </div>
                    <div>
                        <ButtonLoader
                            :loading="loadingButton"
                            :styled="'btn btn-primary btn-block btn-lg'"
                            :disabled="
                                !customer.account_verified_data ||
                                customer.account_verified_data.status !=
                                    'APPROVED' ||
                                !customer.customer_business ||
                                !qris_merchant_data.qris_provider_id
                            "
                            @click.native="submit()"
                        >
                            Lanjutkan</ButtonLoader
                        >
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Opsi Providers -->
        <action-sheet
            ref="option_providers"
            :title="'Pilih Jenis & Penerbit QRIS'"
            :inset="false"
            :content-full="true"
            :contentHeight="false"
            :fullDisplay="true"
        >
            <div
                class="text-center mt-5 pt-5 mb-5 pb-5"
                v-if="loadingActionSheet"
            >
                <span
                    class="spinner-border spinner-border mr-1 text-primary"
                    role="status"
                    aria-hidden="true"
                ></span>
            </div>
            <div v-else>
                <ul
                    class="listview image-listview"
                    v-if="qris_providers.length > 0"
                >
                    <li v-for="item in qris_providers" :key="item.id">
                        <a
                            style="cursor: pointer"
                            class="item disabled"
                            @click="selectProvider(item)"
                        >
                            <div class="in">
                                <div>
                                    <b>{{ item.name }}</b>
                                    <footer>
                                        Diterbitkan oleh {{ item.provider_by }}
                                    </footer>
                                </div>
                            </div>
                        </a>
                    </li>
                </ul>
                <div class="text-center" v-else>
                    <img
                        :src="require('@/assets/image/empty.webp')"
                        alt="404"
                        class="w-75"
                    /><br />
                    <h2 class="mb-0">Provider QRIS belum tersedia</h2>
                </div>
            </div>
        </action-sheet>

        <action-sheet
            ref="modalTermOfService"
            :title="'Syarat & Ketentuan QRIS Merchant'"
            :header="true"
            :inset="false"
            :footer="true"
        >
            <term-of-service></term-of-service>

            <template #footer>
                <div
                    class="text-center"
                    style="font-size: 12px; line-height: 150%"
                >
                    <p>
                        Dengan memilih tombol "<b>Ya, Setuju</b>" Anda telah
                        menyetujui <b>Syarat dan Ketentuan</b> ini
                    </p>
                </div>
                <div class="form-group basic pb-0">
                    <div class="row">
                        <div class="col-6">
                            <button
                                class="btn btn-outline-primary btn-block btn-lg"
                                style="height: 40px; border-width: 1px"
                                @click="modalTermOfService('hide')"
                            >
                                Tidak
                            </button>
                        </div>
                        <div class="col-6">
                            <ButtonLoader
                                :loading="false"
                                :styled="'btn btn-primary btn-block btn-lg'"
                                style="height: 40px"
                                @click.native="nextToRegistration()"
                                >Ya, Setuju</ButtonLoader
                            >
                        </div>
                    </div>
                </div>
            </template>
        </action-sheet>
        <!-- dialog Clear Cache -->
        <Dialog
            ref="dialog_alert_coming"
            :loading="false"
            :title="'Informasi'"
            @confirm="showAlertComing('hide')"
            :icon="'warning'"
        >
            <span class="text-standar"
                >Fitur ini masih dalam pengembangan dan akan segera tersedia,
                saat fitur ini sudah tersedia akan kami informasikan.</span
            >
        </Dialog>
    </div>
</template>
<script>
    import { mapActions, mapState } from 'vuex';
    import carousel from 'vue-owl-carousel';
    export default {
        components: { carousel },
        props: ['opening'],
        data() {
            return {
                loading: {
                    content: false,
                },
                loadingApp: false,
                loadingActionSheet: false,
                loadingButton: false,
                showOpeningSlider: this.opening,
                sliderOpening: [
                    {
                        id: 1,
                        urlImage: require('@/assets/carosel-qris/1.jpg'),
                    },
                    {
                        id: 2,
                        urlImage: require('@/assets/carosel-qris/2.jpg'),
                    },
                    {
                        id: 3,
                        urlImage: require('@/assets/carosel-qris/3.jpg'),
                    },
                    {
                        id: 4,
                        urlImage: require('@/assets/carosel-qris/4.jpg'),
                    },
                ],
                showButtonRegister: false,
                selectProviderData: {
                    name: '',
                    provider_by: '',
                    description: '',
                    qris_payment_fees: [],
                },
            };
        },
        created() {
            //
        },
        computed: {
            ...mapState(['toast', 'VUE_ENV', 'customer', 'setting']),
            ...mapState('qrisMerchant', {
                qris_providers: state => state.qris_providers,
                qris_merchant_data: state => state.qris_merchant_data,
            }),
        },
        methods: {
            ...mapActions('qrisMerchant', [
                'getQrisProvider',
                'storeQrisMerchant',
            ]),
            modalTermOfService(value) {
                let element = this.$refs.modalTermOfService.$el;
                window.$(element).modal(value);
            },
            modalOptionProviders(value) {
                this.loadingActionSheet = true;
                let element = this.$refs.option_providers.$el;
                window.$(element).modal(value);

                if (value == 'show') {
                    this.getQrisProvider().then(() => {
                        this.loadingActionSheet = false;
                    });
                }
            },
            selectProvider(data) {
                this.qris_merchant_data.qris_provider_id = data.id;
                this.selectProviderData = data;
                console.log(data);
                this.modalOptionProviders('hide');
            },
            submit() {
                this.loadingButton = true;
                this.storeQrisMerchant().then(response => {
                    this.loadingButton = false;
                    this.$router.push({
                        name: 'qris.list.detail',
                        params: { id: response.responseData.id },
                    });
                });
            },
            nextToRegistration() {
                this.modalTermOfService('hide');
                this.showOpeningSlider = false;
            },
            onCarouselChanged(event) {
                // event.item.index = index saat ini
                // event.item.count = total slide
                const current = event.item.index;
                const total = event.item.count;

                if (!this.showButtonRegister) {
                    this.showButtonRegister = current === total - 1; // ✅ Jika terakhir, tampilkan tombol daftar
                }
            },
        },

        mounted() {},
    };
</script>
<style>
    .table-min th,
    .table-min td {
        padding: 0.5rem 0.75rem 0.5rem 0.75rem;
    }
</style>
